module.exports = __webpack_public_path__ + "assets/img/signin_path_bg.bb667c36.png";